import {
	facebook,
	instagram,
	tiktok,
	twitter,
	youtube,
} from "../../commons/constants/redirects";
import { useLocation } from "react-router-dom";
import { IProps } from "../../types/CommonTypes";
import { getImageById } from "../../commons/constants/helpers";
import { NAV_LINKS } from "../landing/Header";
import "../landing/landing.css";

const SOCIALS = [
	{ label: "Instagram", source: require("../../assets/social/instagram.png"), href: instagram },
	{ label: "TikTok", source: require("../../assets/social/tiktok.png"), href: tiktok },
	{ label: "Facebook", source: require("../../assets/social/facebook.png"), href: facebook },
	{ label: "X", source: require("../../assets/social/x.png"), href: twitter },
	{ label: "YouTube", source: require("../../assets/social/youtube.png"), href: youtube },
];

const Footer = ({ item }: IProps) => {
	const { pathname } = useLocation();
	// El footer también se renderiza en /blogs, donde las secciones del home no
	// existen: allí las anclas tienen que volver al home antes de saltar.
	const isHome = pathname === "/";

	return (
		<footer
			className="ld-footer"
			style={{
				backgroundImage: `url(${getImageById("banner", item)})`,
			}}
		>
			<div className="ld-footer-overlay" />
			<div className="ld-container ld-footer-content">
				<img
					className="ld-footer-logo"
					src={getImageById("name2", item)}
					alt="Daniel Briceño — Control con verdad"
				/>

				<nav className="ld-footer-nav" aria-label="Mapa del sitio">
					{NAV_LINKS.map((link) => (
						<a
							key={link.href}
							href={isHome ? link.href : `/${link.href}`}
						>
							{link.label}
						</a>
					))}
				</nav>

				<div className="ld-footer-social">
					{SOCIALS.map((social) => (
						<a
							key={social.label}
							href={social.href}
							target="_blank"
							rel="noopener noreferrer"
							aria-label={social.label}
						>
							<img src={social.source} alt={social.label} />
						</a>
					))}
				</div>

				<p className="ld-footer-copy">
					© {new Date().getFullYear()} Daniel Briceño <br />
					Prohibida su distribución para fines maliciosos <br />
					Desarrollado por{" "}
					<a
						href="https://survivorslabs.com"
						target="_blank"
						rel="noopener noreferrer"
					>
						Survivors Labs
					</a>
				</p>
			</div>
		</footer>
	);
};

export default Footer;
